<div class="mainpanel">
    <h2 class="mat-title">Judge Tools</h2>
    <div class="buttonRow" fxLayout="row" fxLayoutGap="15px">
        <button mat-raised-button color="primary" (click)="AddJudge()">Add New Judge</button>
        <button mat-raised-button color="primary" (click)="GetSpreadsheet()">Get Blank Spreadsheet</button>
        <button mat-raised-button color="primary" (click)="UploadSpreadsheet()">Upload Spreadsheet</button>
        <button mat-raised-button color="primary" (click)="EmailJudges()">Email Announcement to Judges</button>
        <button mat-raised-button color="primary" (click)="DivideJudges()" *ngIf="IsHOF === true">Set Judge Groups</button>
    </div>
    <div>
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>

        <div class="mat-elevation-z8 tableCard">
            <mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="JudgingKey">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="centerText">Judging Key</mat-header-cell>
                    <mat-cell *matCellDef="let row">{{row.JudgingKey}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="SortableName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
                    <mat-cell *matCellDef="let row">{{row.SortableName}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="PhaseName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Judging Phase</mat-header-cell>
                    <mat-cell *matCellDef="let row">{{row.PhaseName}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="DistrictNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>District</mat-header-cell>
                    <mat-cell *matCellDef="let row">{{row.DistrictNumber}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="NomineeTypeName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Nomination</mat-header-cell>
                    <mat-cell *matCellDef="let row">{{row.NomineeTypeName}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Actions</mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <div fxLayout="row wrap">
                            <button class="buffer" mat-raised-button color="primary" (click)="EditJudge(row)">Edit Judge</button>
                            <button class="buffer" mat-raised-button color="warn" (click)="RemoveJudge(row)">Remove Judge</button>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

            <mat-paginator [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
        </div>
    </div>
</div>